import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Text } from "shared";
import { SPECIAL_STATUS_OPTIONS } from "../constants";

interface BulkEditModalProps {
  open: boolean;
  selectedCount: number;
  onClose: () => void;
  onConfirm: (fields: Record<string, string | null>) => void;
}

const BulkEditModal: React.VFC<BulkEditModalProps> = ({ open, selectedCount, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const [status, setStatus] = useState("");
  const [comments, setComments] = useState("");

  const handleApply = () => {
    const fields: Record<string, string | null> = {};
    if (status) {
      fields.special_status = status;
    }
    if (comments.trim()) {
      fields.comments = comments.trim();
    }
    onConfirm(fields);
    setStatus("");
    setComments("");
    onClose();
  };

  const handleClose = () => {
    setStatus("");
    setComments("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {t("referral_tracking.bulk_edit")} ({selectedCount} {t("referral_tracking.selected")})
      </DialogTitle>
      <DialogContent>
        <Text tiny secondary>
          {t("referral_tracking.bulk_edit_hint")}
        </Text>
        <Box mt={2} mb={2}>
          <FormControl variant="outlined" size="small" fullWidth>
            <InputLabel>{t("referral_tracking.special_status")}</InputLabel>
            <Select
              value={status}
              onChange={e => setStatus(e.target.value as string)}
              label={t("referral_tracking.special_status")}
            >
              <MenuItem value="">
                <em>{t("referral_tracking.no_change")}</em>
              </MenuItem>
              {SPECIAL_STATUS_OPTIONS.filter(o => o.value).map(opt => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <TextField
          label={t("referral_tracking.comments")}
          multiline
          rows={3}
          variant="outlined"
          fullWidth
          value={comments}
          onChange={e => setComments(e.target.value)}
          placeholder={t("referral_tracking.bulk_comment_placeholder")}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t("referral_tracking.cancel")}</Button>
        <Button onClick={handleApply} variant="contained" color="primary" disabled={!status && !comments.trim()}>
          {t("referral_tracking.apply")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkEditModal;
